import React from 'react';
import { colors } from './theme';

export default function TestGpvBanner() {
  return (
    <div style={bannerStyle}>
      TEST ENVIRONMENT � showing data from poc_test
    </div>
  );
}

const bannerStyle = {
  background: `linear-gradient(90deg, ${colors.danger} 0%, #ff6b6b 100%)`,
  color: colors.background,
  textAlign: 'center',
  fontWeight: 700,
  padding: '0.85rem 1rem',
  letterSpacing: '0.1em',
  textTransform: 'uppercase'
};
